module.exports = __webpack_public_path__ + "static/media/3s_bis_02.102d9640.png";